export default __webpack_public_path__ + "static/media/Redighieri.3cfa7ba8.jpg";